/* esm.sh - rxjs@7.8.1/dist/esm/internal/util/isPromise */
import{isFunction as o}from"./isFunction.mjs";function r(i){return o(i?.then)}export{r as isPromise};
//# sourceMappingURL=isPromise.mjs.map